import { ApiResult } from 'types';
import { fetchAuthSession } from 'aws-amplify/auth';
import { API_BASE_URL, API_PR_URL } from 'utils/constants';

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  let token: string | undefined;

  try {
    const session = await fetchAuthSession();
    token = session.tokens?.idToken?.toString();
  } catch {
    token = undefined;
  }

  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const postRequest = async <T = ApiResult>(
  endpoint: string,
  payload: object
): Promise<T | undefined> => {
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers: await getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};

export const getRequest = async (
  endpoint: string,
  baseUrl: string = API_BASE_URL
): Promise<ApiResult | undefined> => {
  const response = await fetch(`${baseUrl}/${endpoint}`, {
    method: 'GET',
    headers: await getAuthHeaders(),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};

export const putRequestWithPRBE = async (endpoint: string) => {
  const response = await fetch(`${API_PR_URL}/${endpoint}`, {
    method: 'PUT',
    headers: await getAuthHeaders(),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};

export const postRequestWithPRBE = async (endpoint: string, payload: object) => {
  const response = await fetch(`${API_PR_URL}/${endpoint}`, {
    method: 'POST',
    headers: await getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};

export const getRequestWithPRBE = async (endpoint: string) => {
  const response = await fetch(`${API_PR_URL}/${endpoint}`, {
    method: 'GET',
    headers: await getAuthHeaders(),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};
